/* drowsie-cart.js — the shared one-plan cart (MN 2026-09-24, modelled on whoop.com's mobile cart).
   • a cart icon with a count badge in <header class="hdr">, between the Order Now pill and the sandwich
   • a sheet that slides over the page: the item, an order summary, Checkout and Keep shopping
   • ONE plan at a time — adding a different plan replaces the current one
   • Checkout hands every plan to the one Stripe checkout, /pages/checkout-embedded (MN 09-24: "keep it consistent"):
       Just you      → ?plan=early   (the server turns early into public once the launch batch is closed)
       Partner Pack  → ?plan=pair    (two Just-you plans at 20% off; renews for both)
       Drowsie only  → ?plan=speaker (one payment, no subscription)
   API: window.DrowsieCart = { add(plan, qty?), open(), close(), clear(), get() } and a window 'dz:cart' event.
   Plans: club | partner | solo (the /pages/product tier keys), or early/justyou, pair, speaker.
   Injects its own CSS, so a page needs only its script tag. Owner: the checkout agent; system: WEB-SYSTEM.md. */
(function () {
  'use strict';
  if (window.DrowsieCart) return;

  var KEY = 'dz_cart';
  var TTL = 30 * 864e5;              // a cart left alone for 30 days is forgotten
  var AFTER_CHECKOUT = 2 * 36e5;     // and 2 h after Checkout was opened (the buyer has most likely paid)
  var ME = document.currentScript;
  var ASSETS = ((ME && ME.src) || '').replace(/[^\/]*$/, '');
  // staging copies point Checkout at the staged checkout page: <script ... data-checkout="/pages/checkout-embedded-staging">
  var STRIPE_PAGE = (ME && ME.getAttribute('data-checkout')) || '/pages/checkout-embedded';

  // Market + prices (2026-09-25, UK / NZ / Canada local currency approved by MN). IDENTICAL to snippets/drowsie-market —
  // pages that render the snippet share its copy; this one covers the rest. Order: ?country= → domain → timezone → US.
  var MK = (function () {
    if (window.DZ_MARKET) return { market: window.DZ_MARKET, CUR: window.DZ_CUR, P: window.DZ_P };
    var CUR = { AU: 'AUD', US: 'USD', GB: 'GBP', NZ: 'NZD', CA: 'CAD' };
    var P = {
      AU: { early: 199, renew: 99, pair: 318.40, speaker: 249, gift: 199 },
      US: { early: 149, renew: 75, pair: 238.40, speaker: 179, gift: 149 },
      GB: { early: 109, renew: 55, pair: 174.40, speaker: 129, gift: 109 },
      NZ: { early: 249, renew: 119, pair: 398.40, speaker: 299, gift: 249 },
      CA: { early: 199, renew: 99, pair: 318.40, speaker: 249, gift: 199 }
    };
    var CA_TZ = /^america\/(toronto|vancouver|edmonton|winnipeg|halifax|st_johns|regina|montreal|moncton|glace_bay|goose_bay|whitehorse|dawson|dawson_creek|yellowknife|iqaluit|rankin_inlet|resolute|cambridge_bay|inuvik|fort_nelson|creston|atikokan|blanc-sablon|nipigon|thunder_bay|rainy_river|pangnirtung|swift_current)$/;
    var US_TZ = /^(america\/(new_york|chicago|denver|los_angeles|phoenix|anchorage|juneau|sitka|metlakatla|yakutat|nome|adak|boise|detroit|menominee|indianapolis|louisville|indiana\/[a-z_]+|kentucky\/[a-z_]+|north_dakota\/[a-z_]+)|pacific\/honolulu|us\/[a-z_-]+)$/;
    function market() {
      var q = ''; try { q = (new URLSearchParams(location.search).get('country') || '').toUpperCase(); } catch (e) {}
      if (CUR[q]) { try { sessionStorage.setItem('dz_country', q); } catch (e) {} return q; }
      try { var s = sessionStorage.getItem('dz_country'); if (CUR[s]) return s; } catch (e) {}
      var h = location.hostname;
      var tz = ''; try { tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase(); } catch (e) {}
      var local = /^europe\/(london|belfast|guernsey|jersey|isle_of_man)$/.test(tz) ? 'GB' : /^pacific\/(auckland|chatham)$/.test(tz) ? 'NZ' : CA_TZ.test(tz) ? 'CA' : US_TZ.test(tz) ? 'US' : '';
      if (/\.com\.au$/.test(h)) return local || 'AU';     // .com.au: a clear US/CA/GB/NZ timezone wins (CA 09-25; US 10-01, shown = charged)
      if (/\.co\.uk$/.test(h)) return 'GB';
      if (/\.co\.nz$/.test(h)) return 'NZ';
      if (/\.ca$/.test(h)) return 'CA';
      if (tz.indexOf('australia/') === 0) return 'AU';
      if (/^europe\/(london|belfast|guernsey|jersey|isle_of_man)$/.test(tz)) return 'GB';
      if (/^pacific\/(auckland|chatham)$/.test(tz)) return 'NZ';
      if (CA_TZ.test(tz)) return 'CA';
      return (navigator.language || '').toLowerCase().slice(-3) === '-au' ? 'AU' : 'US';
    }
    return { market: market, CUR: CUR, P: P };
  })();
  var M = MK.market(), MP = MK.P[M] || MK.P.US, MCUR = MK.CUR[M] || 'USD';
  var AU = M === 'AU';
  function sym(cur) { return { AUD: 'A$', USD: 'US$', GBP: '£', NZD: 'NZ$', CAD: 'C$' }[cur] || cur + ' '; }
  function fmt(v) { return sym(MCUR) + (Math.round(v * 100) % 100 ? v.toFixed(2) : String(Math.round(v))); }

  var PLANS = {
    club: {
      line: 'Just you · a year of Sleep Club', img: 'drowsie-cart-pillow.jpg', units: 1, engine: 'stripe', plan: 'early', max: 1, gaName: 'Drowsie + a year of Sleep Club', gaCat: 'Sleep Club',
      cents: Math.round(MP.early * 100), currency: MCUR,
      then: 'Renews at ' + fmt(MP.renew) + ' a year. Cancel anytime — Drowsie stays yours.'
    },
    partner: {
      line: 'Partner Pack · two Drowsies, a year of Sleep Club each', img: 'drowsie-cart-pillow.jpg', units: 2, engine: 'stripe', plan: 'pair', max: 1, gaName: 'Partner Pack', gaCat: 'Sleep Club',
      cents: Math.round(MP.pair * 100), currency: MCUR,
      then: 'Renews at ' + fmt(2 * MP.renew) + ' a year for both. Cancel anytime — Drowsie stays yours.'
    },
    solo: {
      line: 'Drowsie only · no subscription', img: 'drowsie-cart-pillow.jpg', units: 1, engine: 'stripe', plan: 'speaker', max: 1, oneOff: true, gaName: 'Drowsie only', gaCat: 'Speaker',
      cents: Math.round(MP.speaker * 100), currency: MCUR,
      then: 'One payment. No subscription — nothing renews.'
    }
  };
  var ALIAS = { club: 'club', early: 'club', 'public': 'club', justyou: 'club', 'just-you': 'club',
    partner: 'partner', pair: 'partner', solo: 'solo', speaker: 'solo', 'drowsie-only': 'solo' };
  var NAME = 'Drowsie Smart Sleep Machine';

  function priceOf(k) { return { cents: PLANS[k].cents, currency: PLANS[k].currency }; }
  function money(cents, cur) {
    var n = cents / 100;
    return sym(cur) + (cents % 100 ? n.toFixed(2) : n.toLocaleString('en-US'));
  }
  // the product page's breakdown: the price over 12 months and over 365 nights (per Drowsie for the pack)
  function cents2(c, cur) { return sym(cur) + (Math.round(c) / 100).toFixed(2); }
  // per night in pence for the UK ("30p", "24p each"), as the product page writes it (Website 09-25)
  function night(c, cur) { return cur === 'GBP' && Math.round(c) < 100 ? Math.round(c) + 'p' : cents2(c, cur); }

  // ---- state -------------------------------------------------------------------------------------
  function read() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!s || !PLANS[s.plan]) return null;
      var now = Date.now();
      if (now - (s.ts || 0) > TTL || (s.out && now - s.out > AFTER_CHECKOUT)) { localStorage.removeItem(KEY); return null; }
      s.qty = Math.min(PLANS[s.plan].max, Math.max(1, s.qty | 0 || 1));
      return s;
    } catch (e) { return null; }
  }
  var state = read();
  function write(s) {
    state = s;
    try { if (s) localStorage.setItem(KEY, JSON.stringify(s)); else localStorage.removeItem(KEY); } catch (e) {}
    render();
    try { window.dispatchEvent(new CustomEvent('dz:cart', { detail: s ? { plan: s.plan, qty: s.qty } : null })); } catch (e) {}
  }
  addEventListener('storage', function (e) { if (e.key === KEY) { state = read(); render(); } });

  // ---- analytics (Google's 09-25 funnel spec) -----------------------------------------------------
  // One item shape everywhere: item_id = the ?plan key the checkout charges (early | pair | speaker).
  // begin_checkout is NOT fired here — checkout-embedded fires it on load, which covers every way in.
  function gaItem(k) {
    var p = PLANS[k], pr = priceOf(k), price = pr.cents / 100;
    return { currency: pr.currency, value: price,
      items: [{ item_id: p.plan, item_name: p.gaName, item_brand: 'Drowsie', item_category: p.gaCat, price: price, quantity: 1 }] };
  }
  function ga(ev, k) {
    try { if (typeof gtag === 'function') gtag('event', ev, k ? gaItem(k) : { currency: MCUR, value: 0, items: [] }); } catch (e) {}
  }
  function ph(ev, k, extra) {
    try {
      if (!window.posthog || !posthog.capture) return;
      var props = k ? { plan: PLANS[k].plan, value: priceOf(k).cents / 100, currency: priceOf(k).currency } : { plan: null };
      for (var x in (extra || {})) props[x] = extra[x];
      posthog.capture(ev, props);
    } catch (e) {}
  }
  function track(k) {
    var it = gaItem(k);
    try { if (typeof fbq === 'function') fbq('track', 'AddToCart', { content_name: k, content_ids: [PLANS[k].plan], content_type: 'product', value: it.value, currency: it.currency }); } catch (e) {}
    // atc_via 'cart' (GA4 dimension "Add to cart source"): checkout-embedded tags direct Buy-now visits ad / guide / direct
    try { if (typeof gtag === 'function') gtag('event', 'add_to_cart', Object.assign({ atc_via: 'cart' }, it)); } catch (e) {}
  }

  // ---- styles ------------------------------------------------------------------------------------
  var UI = 'cubic-bezier(.23,1,.32,1)', SHEET = 'cubic-bezier(.32,.72,0,1)';
  function styles() {
    if (document.getElementById('dzCartCss')) return;
    var st = document.createElement('style');
    st.id = 'dzCartCss';
    st.textContent = [
      // the header icon
      '.dzc-icon{all:unset;box-sizing:border-box;position:relative;flex:none;display:inline-flex;align-items:center;justify-content:center;',
      '  width:40px;height:40px;margin:0 -7px 0 11px;border-radius:999px;color:#F3EBE5;cursor:pointer;-webkit-tap-highlight-color:transparent;',
      '  transition:transform .16s ' + UI + ',background-color .2s ' + UI + '}',
      '.dzc-icon svg{width:22px;height:22px;display:block}',
      '.dzc-icon:active{transform:scale(.97)}',
      '.dzc-icon:focus-visible{outline:2px solid #F3EBE5;outline-offset:2px}',
      '@media(hover:hover) and (pointer:fine){.dzc-icon:hover{background:rgba(243,235,229,.08)}}',
      'body.is-light .dzc-icon{color:#3B2246}',
      '.dzc-badge{position:absolute;top:3px;right:1px;min-width:17px;height:17px;padding:0 4px;box-sizing:border-box;border-radius:999px;',
      '  background:#A85F62;color:#fff;font:600 10px/17px Inter,-apple-system,BlinkMacSystemFont,sans-serif;text-align:center;',
      '  font-variant-numeric:tabular-nums;box-shadow:0 0 0 2px rgba(11,10,20,.9);transform-origin:50% 50%}',
      '.dzc-badge[hidden]{display:none}',
      '.dzc-badge.dzc-pop{animation:dzcPop .32s ' + UI + '}',
      '@keyframes dzcPop{0%{transform:scale(.6)}60%{transform:scale(1.12)}100%{transform:scale(1)}}',
      // the sheet
      '.dzc{position:fixed;inset:0;z-index:2147483000;font-family:Inter,-apple-system,BlinkMacSystemFont,sans-serif;',
      '  -webkit-font-smoothing:antialiased;color:#F3EBE5}',
      '.dzc[hidden]{display:none}',
      '.dzc *{box-sizing:border-box}',
      '.dzc-scrim{position:absolute;inset:0;background:rgba(5,4,10,.62);opacity:0;transition:opacity .3s ' + SHEET + '}',
      '.dzc-panel{position:absolute;top:0;right:0;bottom:0;width:100%;max-width:440px;display:flex;flex-direction:column;',
      '  background:#0E0C18;border-left:1px solid rgba(255,255,255,.08);box-shadow:-24px 0 64px rgba(0,0,0,.35);',
      '  transform:translate3d(100%,0,0);transition:transform .3s ' + SHEET + ';outline:none;',
      '  padding-top:env(safe-area-inset-top,0px)}',
      '.dzc.is-open .dzc-scrim{opacity:1}',
      '.dzc.is-open .dzc-panel{transform:none}',
      '.dzc.is-closing .dzc-scrim{transition-duration:.2s}',
      '.dzc.is-closing .dzc-panel{transition-duration:.2s}',
      '.dzc-head{display:flex;align-items:center;justify-content:space-between;height:64px;padding:0 12px 0 24px;flex:none;',
      '  border-bottom:1px solid rgba(255,255,255,.08)}',
      '.dzc .dzc-title{margin:0;padding:0;max-width:none;font:400 24px/1.1 Marcellus,Georgia,serif;letter-spacing:0;color:#F3EBE5;text-transform:none}',
      '.dzc-x{all:unset;box-sizing:border-box;width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;',
      '  border-radius:999px;color:#F3EBE5;cursor:pointer;transition:transform .16s ' + UI + ',background-color .2s ' + UI + '}',
      '.dzc-x svg{width:22px;height:22px}',
      '.dzc-body{flex:1;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:20px 20px 8px}',
      // the item card
      '.dzc-item{display:grid;grid-template-columns:88px 1fr;gap:16px;padding:16px;border-radius:20px;',
      '  background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1)}',
      '.dzc-thumb{width:88px;height:88px;border-radius:14px;background:#1a1624;overflow:hidden}',
      '.dzc-thumb img{display:block;width:100%;height:100%;max-width:none;object-fit:cover;margin:0}',
      '.dzc-info{min-width:0;display:flex;flex-direction:column}',
      '.dzc-row{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}',
      '.dzc .dzc-name{margin:0;max-width:none;font:600 15px/1.3 Inter,sans-serif;color:#F3EBE5}',
      '.dzc .dzc-line{margin:4px 0 0;max-width:none;font:400 13px/1.4 Inter,sans-serif;color:rgba(243,235,229,.62)}',
      '.dzc .dzc-price{margin:0;flex:none;font:600 15px/1.3 Inter,sans-serif;color:#F3EBE5;font-variant-numeric:tabular-nums}',
      '.dzc-ctrl{display:flex;align-items:center;gap:8px;margin-top:auto;padding-top:12px}',
      '.dzc-step{display:inline-flex;align-items:center;height:36px;border:1px solid rgba(255,255,255,.18);border-radius:999px}',
      '.dzc-step output{min-width:28px;text-align:center;font:600 14px/1 Inter,sans-serif;font-variant-numeric:tabular-nums;color:#F3EBE5}',
      '.dzc-sb,.dzc-trash{all:unset;box-sizing:border-box;width:36px;height:36px;display:inline-flex;align-items:center;justify-content:center;',
      '  border-radius:999px;color:#F3EBE5;cursor:pointer;transition:transform .16s ' + UI + ',background-color .2s ' + UI + ',opacity .2s ' + UI + '}',
      '.dzc-sb svg,.dzc-trash svg{width:18px;height:18px}',
      '.dzc-sb[disabled]{opacity:.3;cursor:default}',
      // the trash sits at the right edge, under the price, with a 44px tap target (icon aligned to the price's edge)
      '.dzc-trash{width:44px;height:44px;margin:-4px -13px -4px auto;color:rgba(243,235,229,.62)}',
      '.dzc .dzc-then{margin:14px 0 0;max-width:none;font:400 13px/1.45 Inter,sans-serif;color:rgba(243,235,229,.62)}',
      // the order summary
      '.dzc-sum{margin-top:20px;padding:4px 0 0}',
      '.dzc .dzc-eyebrow{margin:0 0 10px;max-width:none;font:600 12px/1 Inter,sans-serif;letter-spacing:.22em;text-transform:uppercase;color:#D4A574}',
      '.dzc-sumrow{display:flex;justify-content:space-between;align-items:baseline;padding:8px 0;font:400 15px/1.3 Inter,sans-serif;',
      '  color:rgba(243,235,229,.78);font-variant-numeric:tabular-nums}',
      '.dzc .dzc-assure{margin:12px 0 0;max-width:none;font:400 13px/1.5 Inter,sans-serif;color:rgba(243,235,229,.62)}',
      '.dzc-ftot .dzc-sumrow.dzc-total{margin:0;padding:0 0 4px;border-top:0}',
      '.dzc-ftot .dzc-assure{margin:0 0 4px}',
      '.dzc-sumrow.dzc-total{margin-top:6px;padding-top:14px;border-top:1px solid rgba(255,255,255,.1);font-weight:600;font-size:17px;color:#F3EBE5}',
      // the buttons
      '.dzc-foot[hidden]{display:none}',
      '.dzc-foot{flex:none;padding:16px 20px calc(16px + env(safe-area-inset-bottom,0px));display:grid;gap:10px;',
      '  border-top:1px solid rgba(255,255,255,.08);background:#0E0C18}',
      '.dzc-go,.dzc-keep{all:unset;box-sizing:border-box;display:flex;align-items:center;justify-content:center;width:100%;height:54px;',
      '  border-radius:999px;font:600 16px/1 Inter,sans-serif;text-align:center;cursor:pointer;-webkit-tap-highlight-color:transparent;',
      '  transition:transform .16s ' + UI + ',opacity .2s ' + UI + ',background-color .2s ' + UI + ',border-color .2s ' + UI + '}',
      '.dzc-go{color:#1A1040;background:linear-gradient(90deg,#C4787A,#D4A574)}',
      '.dzc-go[aria-busy="true"]{opacity:.7;cursor:progress}',
      '.dzc-keep{color:#F3EBE5;border:1px solid rgba(255,255,255,.18)}',
      '.dzc-go:active,.dzc-keep:active,.dzc-sb:not([disabled]):active,.dzc-trash:active,.dzc-x:active{transform:scale(.97)}',
      '.dzc-go:focus-visible,.dzc-keep:focus-visible,.dzc-sb:focus-visible,.dzc-trash:focus-visible,.dzc-x:focus-visible{outline:2px solid #F3EBE5;outline-offset:3px}',
      '@media(hover:hover) and (pointer:fine){',
      '  .dzc-go:hover{opacity:.92}.dzc-keep:hover{border-color:rgba(255,255,255,.36)}',
      '  .dzc-x:hover,.dzc-sb:not([disabled]):hover,.dzc-trash:hover{background:rgba(255,255,255,.08)}}',
      // empty
      '.dzc-empty{padding:48px 4px 0;text-align:center}',
      '.dzc .dzc-empty p{margin:0 auto 24px;max-width:none;font:400 16px/1.5 Inter,sans-serif;color:rgba(243,235,229,.78)}',
      '.dzc-empty .dzc-go{text-decoration:none}',
      // phones: the sheet owns the whole screen
      '@media(max-width:480px){.dzc-panel{max-width:none;border-left:0;box-shadow:none}',
      // phones: keep Total (and the line under it) in view above the pinned buttons — price under the name, tighter rows
      '  .dzc-body{padding-top:16px}.dzc-item{grid-template-columns:72px 1fr;gap:14px;padding:14px}.dzc-thumb{width:72px;height:72px}',
      '  .dzc-row{flex-direction:column;gap:4px}.dzc .dzc-price{order:2}.dzc-sumrow{padding:6px 0}.dzc-sum{margin-top:14px}.dzc .dzc-then{margin-top:12px}',
      '  .dzc-foot{gap:8px;padding-top:12px}.dzc-keep{height:44px;font-size:15px}}',
      '@media(min-width:481px){.dzc-body{flex:0 1 auto}.dzc-foot{border-top:0;padding-top:4px}}',
      'html.dzc-lock,html.dzc-lock body{overflow:hidden!important}',
      '@media(prefers-reduced-motion:reduce){',
      '  .dzc-panel{transform:none;opacity:0;transition:opacity .15s linear}',
      '  .dzc.is-open .dzc-panel{opacity:1}',
      '  .dzc-scrim,.dzc.is-closing .dzc-scrim,.dzc.is-closing .dzc-panel{transition-duration:.15s}',
      '  .dzc-badge.dzc-pop{animation:none}}'
    ].join('\n');
    document.head.appendChild(st);
  }

  var I = {
    bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    x: '<path d="M18 6 6 18M6 6l12 12"/>',
    minus: '<path d="M5 12h14"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    trash: '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>'
  };
  function svg(p) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>';
  }

  // ---- the header icon ---------------------------------------------------------------------------
  var icon = null, badge = null;
  function mountIcon() {
    var hdr = document.querySelector('header.hdr');
    if (!hdr || hdr.querySelector('.dzc-icon')) return;
    icon = document.createElement('button');
    icon.type = 'button';
    icon.className = 'dzc-icon';
    icon.setAttribute('aria-haspopup', 'dialog');
    icon.setAttribute('aria-expanded', 'false');
    icon.innerHTML = svg(I.bag) + '<span class="dzc-badge" hidden></span>';
    badge = icon.querySelector('.dzc-badge');
    icon.addEventListener('click', function () { api.open(); });
    // after the Order Now pill that drowsie-nav.js injects, before the sandwich — whichever script runs first
    function place() {
      var cta = hdr.querySelector('.hdr_cta'), burger = hdr.querySelector('.burger');
      if (cta) cta.parentNode.insertBefore(icon, cta.nextSibling);
      else if (burger) burger.parentNode.insertBefore(icon, burger);
      else hdr.appendChild(icon);
      icon.style.marginLeft = cta ? '' : 'auto';
      return !!cta;
    }
    if (!place() && window.MutationObserver) {
      var mo = new MutationObserver(function () { if (hdr.querySelector('.hdr_cta')) { mo.disconnect(); place(); } });
      mo.observe(hdr, { childList: true });
      setTimeout(function () { mo.disconnect(); }, 10000);
    }
    renderIcon(false);
  }
  function renderIcon(pop) {
    if (!icon) return;
    var n = state ? state.qty : 0;
    badge.textContent = n;
    badge.hidden = !n;
    icon.setAttribute('aria-label', n ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart, empty');
    if (pop && n) { badge.classList.remove('dzc-pop'); void badge.offsetWidth; badge.classList.add('dzc-pop'); }
  }

  // ---- the sheet ---------------------------------------------------------------------------------
  var root = null, panel = null, body = null, foot = null, ftot = null, goBtn = null, lastFocus = null, closeTimer = 0;
  function mountSheet() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'dzc';
    root.hidden = true;
    root.innerHTML =
      '<div class="dzc-scrim" data-dzc-close></div>' +
      '<div class="dzc-panel" role="dialog" aria-modal="true" aria-labelledby="dzcTitle" tabindex="-1">' +
        '<div class="dzc-head"><h2 class="dzc-title" id="dzcTitle">Your cart</h2>' +
        '<button type="button" class="dzc-x" aria-label="Close cart" data-dzc-close>' + svg(I.x) + '</button></div>' +
        '<div class="dzc-body"></div>' +
        '<div class="dzc-foot">' +
          '<div class="dzc-ftot"></div>' +
          '<button type="button" class="dzc-go">Checkout</button>' +
          '<button type="button" class="dzc-keep" data-dzc-close>Keep shopping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    panel = root.querySelector('.dzc-panel');
    body = root.querySelector('.dzc-body');
    foot = root.querySelector('.dzc-foot');
    goBtn = root.querySelector('.dzc-go');
    ftot = root.querySelector('.dzc-ftot');
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-dzc-close],[data-dzc-step],[data-dzc-remove]') : null;
      if (!t) return;
      if (t.hasAttribute('data-dzc-close')) { api.close(); return; }
      if (t.hasAttribute('data-dzc-remove')) {
        if (state) { ga('remove_from_cart', state.plan); ph('cart_remove', state.plan, { reason: 'trash' }); }
        api.clear();
        var cta = body.querySelector('.dzc-go'); if (cta) cta.focus({ preventScroll: true });
        return;
      }
      if (t.hasAttribute('data-dzc-step') && state) {
        var dir = t.getAttribute('data-dzc-step');
        var q = Math.min(PLANS[state.plan].max, Math.max(1, state.qty + (+dir)));
        if (q === state.qty) return;
        write({ plan: state.plan, qty: q, ts: Date.now() });
        renderIcon(true);
        var same = body.querySelector('[data-dzc-step="' + dir + '"]:not([disabled])') || body.querySelector('[data-dzc-step]:not([disabled])');
        if (same) same.focus({ preventScroll: true });
      }
    });
    goBtn.addEventListener('click', checkout);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden && root.classList.contains('is-open')) api.close();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(panel.querySelectorAll('button:not([disabled]),a[href]'),
        function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function render() {
    renderIcon(false);
    if (!root) return;
    if (!state) {
      var onProduct = /^\/pages\/product\/?$/.test(location.pathname);
      body.innerHTML = '<div class="dzc-empty"><p>Your cart is empty.</p>' +
        '<a class="dzc-go" href="' + (onProduct ? '#plan' : '/pages/product#plan') + '" data-dzc-close>Order Now</a></div>';
      foot.hidden = true;
      return;
    }
    var k = state.plan, p = PLANS[k], pr = priceOf(k), line = pr.cents * state.qty, units = p.units * state.qty;
    var ctrl = p.max > 1
      ? '<div class="dzc-step" role="group" aria-label="Quantity">' +
          '<button type="button" class="dzc-sb" data-dzc-step="-1" aria-label="One fewer"' + (state.qty <= 1 ? ' disabled' : '') + '>' + svg(I.minus) + '</button>' +
          '<output aria-live="polite">' + state.qty + '</output>' +
          '<button type="button" class="dzc-sb" data-dzc-step="1" aria-label="One more"' + (state.qty >= p.max ? ' disabled' : '') + '>' + svg(I.plus) + '</button>' +
        '</div>'
      : '';
    body.innerHTML =
      '<div class="dzc-item">' +
        '<div class="dzc-thumb"><img src="' + ASSETS + p.img + '" alt="" width="88" height="88"></div>' +
        '<div class="dzc-info">' +
          '<div class="dzc-row"><div><p class="dzc-name">' + NAME + '</p><p class="dzc-line">' + p.line + '</p></div>' +
          '<p class="dzc-price">' + money(line, pr.currency) + '</p></div>' +
          '<div class="dzc-ctrl">' + ctrl +
            '<button type="button" class="dzc-trash" data-dzc-remove aria-label="Remove from cart">' + svg(I.trash) + '</button></div>' +
        '</div>' +
      '</div>' +
      (p.then ? '<p class="dzc-then">' + p.then + '</p>' : '') +
      '<div class="dzc-sum">' +
        '<p class="dzc-eyebrow">Order summary</p>' +
        // a one-off payment has no monthly figure (Website's audit 09-25)
        (p.oneOff ? '<div class="dzc-sumrow"><span>One payment</span><span>Nothing renews</span></div>'
                  : '<div class="dzc-sumrow"><span>Per month</span><span>' + cents2(line / 12, pr.currency) + '</span></div>') +
        '<div class="dzc-sumrow"><span>' + (units > 1 ? 'Per night, each' : 'Per night') + '</span><span>' + night(line / 365 / units, pr.currency) + '</span></div>' +
        '<div class="dzc-sumrow"><span>Shipping</span><span>Free</span></div>' +
      '</div>';
    // …and sit in the bar with the buttons, so Total is never scrolled out of view on a phone (Website's audit 09-25)
    ftot.innerHTML =
      '<div class="dzc-sumrow dzc-total"><span>Total</span><span>' + money(line, pr.currency) + '</span></div>' +
      '<p class="dzc-assure">Free shipping · arrives in about a week (two to three weeks outside Australia) · 60-night money-back guarantee (use it on at least 30 of your first 60 nights)</p>';
    foot.hidden = false;
  }

  // Checkout: the Stripe page with the plan's key. Carries the visit's tags along, like every buy link on the site.
  var PASS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'via'];
  function checkout() {
    if (!state || goBtn.getAttribute('aria-busy') === 'true') return;
    var p = PLANS[state.plan], here = new URLSearchParams(location.search);
    // no ?country here (10-01): Shopify treats it as a market switch and jumps .com.au → .co.uk / .co.nz, leaving the bag
    // behind on the old domain. Checkout works out the same market itself (same drowsie-market rule, same host, same session).
    var q = new URLSearchParams({ plan: p.plan });
    PASS.forEach(function (n) { var v = here.get(n); if (v) q.set(n, v); });
    var url = STRIPE_PAGE + '?' + q.toString();
    ph('cart_checkout_click', state.plan);
    goBtn.setAttribute('aria-busy', 'true');
    goBtn.textContent = 'Opening checkout…';
    try { var s = read(); if (s) { s.out = Date.now(); localStorage.setItem(KEY, JSON.stringify(s)); } } catch (e) {}
    location.href = url;
  }
  // back/forward cache: a page restored after Checkout must not keep the busy button
  addEventListener('pageshow', function (e) {
    if (!e.persisted || !goBtn) return;
    goBtn.removeAttribute('aria-busy'); goBtn.textContent = 'Checkout';
  });

  var scrollbar = 0;
  var api = {
    add: function (plan, qty) {
      var k = ALIAS[String(plan || '').toLowerCase()];
      if (!k) { if (window.console) console.warn('DrowsieCart: unknown plan', plan); return null; }
      // the same plan again keeps its quantity; a different plan replaces the cart
      var n = qty ? qty | 0 : (state && state.plan === k ? state.qty : 1);
      n = Math.min(PLANS[k].max, Math.max(1, n));
      var was = state && state.plan !== k ? state.plan : null;
      if (was) { ga('remove_from_cart', was); ph('cart_remove', was, { reason: 'swap' }); }
      write({ plan: k, qty: n, ts: Date.now() });
      renderIcon(true);
      track(k);
      ph('cart_add', k, was ? { swapped_from: PLANS[was].plan } : null);
      api.open();
      return api.get();
    },
    open: function () {
      boot();
      render();
      if (document.body.classList.contains('menu-open')) {
        var b = document.querySelector('header.hdr .burger'); if (b) b.click();
      }
      clearTimeout(closeTimer);
      root.classList.remove('is-closing');
      if (!root.hidden && root.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      ga('view_cart', state ? state.plan : null);
      ph('cart_view', state ? state.plan : null);
      scrollbar = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.classList.add('dzc-lock');
      if (scrollbar > 0) document.body.style.paddingRight = scrollbar + 'px';
      root.hidden = false;
      void panel.offsetWidth;                         // commit the closed position, then animate to open
      root.classList.add('is-open');
      if (icon) icon.setAttribute('aria-expanded', 'true');
      panel.focus({ preventScroll: true });
    },
    close: function () {
      if (!root || root.hidden) return;
      root.classList.add('is-closing');
      root.classList.remove('is-open');
      if (icon) icon.setAttribute('aria-expanded', 'false');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        root.hidden = true;
        root.classList.remove('is-closing');
        document.documentElement.classList.remove('dzc-lock');
        document.body.style.paddingRight = '';
      }, 220);
      if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    },
    clear: function () { write(null); },
    get: function () {
      if (!state) return null;
      var pr = priceOf(state.plan);
      return { plan: state.plan, qty: state.qty, engine: PLANS[state.plan].engine, name: NAME,
        line: PLANS[state.plan].line, total: pr.cents * state.qty / 100, currency: pr.currency };
    }
  };
  window.DrowsieCart = api;

  var booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    styles();
    mountIcon();
    mountSheet();
    render();
    ga('view_item', 'club');
    if (location.hash === '#cart') api.open();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
